export const JSONParse = <T>(value: string): T | undefined => {
  try {
    return JSON.parse(value)
  } catch (error: unknown) {
    console.error(error)
    return undefined
  }
}

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)
